import { isDateGreaterThanToday } from '@/helpers';
import { MAX_CAGE_POPULATION } from '@/constants/cage';

export const validationSchema = {
  totalCages: {
    min: {
      value: 0,
      message: 'You must create atleast one cage',
    },
    max: {
      value: 200,
      message: 'You can create a maximum of 200 cages per study',
    },
  },
  collections: {
    name: {
      minLength: {
        value: 3,
        message: 'Longer than 3 characters',
      },
      maxLength: {
        value: 50,
        message: 'Less than 50 characters',
      },
      required: 'Required',
    },
    subjects: {
      min: {
        value: 0,
        message: 'Create atleast one subject',
      },
      max: {
        value: MAX_CAGE_POPULATION,
        message: `Maximum of ${MAX_CAGE_POPULATION}`,
      },
      required: 'Required',
    },
    sex: {
      required: 'Required',
    },
    dob: {
      required: 'Required',
      validate: (value: string): string | true =>
        isDateGreaterThanToday(new Date(value)) ? 'D.O.B cannot be in the future' : true,
    },
  },
};
